<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <div class="page-header">
        <h2 class="header-title">Downloads</h2>
        <div class="header-sub-title">
          <nav class="breadcrumb breadcrumb-dash">
            <router-link :to="`/`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Home
            </router-link>
            <span class="breadcrumb-item active">Downloads</span>
          </nav>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="m-t-25">
            <section v-if="!isLoading">
              <div class="row">
                <div class="col-lg-12 add-form">
                  <input class="form-control datatable_search" @keyup="searchDatatable" placeholder="Search..."/>
                </div>
              </div>
              <table class="dataTable table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Username</th>
                    <th>Type</th>
                    <th>Type Name</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="download in downloads" :key="download.id">
                    <td>{{download.id}}</td>
                    <td>{{download.username}}</td>
                    <td>{{download.type}}</td>
                    <td>{{download.typeName}}</td>
                    <td>
                      <span style="display:none;">
                        {{new Date(download.created_at).getTime()}}
                      </span>
                      {{download.created_at}}
                    </td>
                  </tr>
                </tbody>
                <tfoot></tfoot>
              </table>
            </section>
            <div class="main-loader" v-else>
              <MainLoader></MainLoader>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Content Wrapper END -->
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  name: 'Accounts',
  data () {
    return {
      datatable: null,
      downloads: []
    }
  },
  computed: {
    isLoading () {
      if (this.downloads.length === 0) { return this.$store.getters.apiStatus === 'loading' } else return false
    }
  },
  mounted () {
    let dataTableScript = document.createElement('script')
    dataTableScript.setAttribute('src', 'https://cdn.datatables.net/1.10.22/js/jquery.dataTables.min.js')
    document.head.appendChild(dataTableScript)
    this.fetchDownloads()
  },
  methods: {
    fetchDownloads () {
      this.downloads = []
      this.$store.dispatch('fetchDownloads')
        .then((result) => {
          this.downloads = result.data.downloads
          setTimeout(() => this.initDatatables(), 100)
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    searchDatatable (e) {
      this.datatable.search(e.target.value).draw()
    },
    initDatatables () {
      this.datatable = $('table').DataTable({
        destroy: true,
        stateSave: true,
        pagingType: 'full_numbers',
        stateSaveCallback: function (settings, data) {
          localStorage.setItem('DataTables_accounts_page', JSON.stringify(data))
        },
        stateLoadCallback: function (settings) {
          return JSON.parse(localStorage.getItem('DataTables_accounts_page'))
        },
        drawCallback: function (settings) {
          $('.previous').html("<img src='/static/images/left_arrow.svg'>")
          $('.next').html("<img src='/static/images/right_arrow.svg'>")
          $('.first').addClass('d-inline')
          $('.first').html("<img src='/static/images/left_arrow.svg'><img src='/static/images/left_arrow.svg'>")
          $('.last').addClass('d-inline')
          $('.last').html("<img src='/static/images/right_arrow.svg'><img src='/static/images/right_arrow.svg'>")
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Downloads.vue